//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const MatchSignupPayment = require('@/tbs/model/to/MatchSignupPayment')
const matchSignupPayment = new MatchSignupPayment
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupMemberConfig = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupMemberConfig.prototype = {
    /* The view object name */
    name: 'matchGroup',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchPlayerSignupSetting',
            query: {
                matchId: 'id',
            },
            basePath: 'data',
            rule: {
                id: '$id',
                isMemberNameChecked: '@trueName',
                isMemberNumChecked: '@number',
                isMemberContactPhoneChecked: '@mobile',
                isMemberGenderChecked: '@gender',
                isMemberBirthChecked: '@bmBirthday',
                isMemberCredentialsChecked: '@IDCard',
                isMemberHeightChecked: '@high',
                isMemberWeightChecked: '@weight',
                isMemberSuitSizeChecked: '@jerseysSize',
                isMemberShoeSizeChecked: '@shoesSize',
                isMemberParentNameChecked: '@guardianName',
                isMemberParentContactPhoneChecked: '@guardianMobile',
                isMemberSchoolChecked: '@school',
                isMemberInsuranceChecked: '@insureFile',
                isMemberPositionChecked: '@position',
                isMemberQualificationChecked: '@qualificationFile',
                isMemberSuitNameChecked: '@jerseyName',
                isMemberDutyChecked: '@title',
                isMemberCityChecked: '@domicileAreaId',
                isMemberNationChecked: '@ethnicity',
                isMemberCountryChecked: '@nationality',
                isMemberWorkUnitChecked: '@enterprise',
                isMemberProfessionChecked: '@post',
                isMemberTeamChecked: '@joinTeam',
                isMemberRegistrationCodeChecked: '@serialNumber',
                isMemberProfessionalPlayerChecked: '@isProfessionalPlayer',
                isMemberEmergencyContactChecked: '@emergencyContactName',
                isMemberRemarkChecked: '@remark',
                isMemberGenderReadonly: '$genderLimit',
                isMemberBirthReadonly: '@isOpenAgeLimit',
                memberCredentialsItems: '$certTypeFields',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchPlayerSignupSetting',
            basePath: '',
            rule: {
                matchId: 'id',
                trueName: '(1)',
                number: '#isMemberNumChecked',
                mobile: '#isMemberContactPhoneChecked',
                gender: '#isMemberGenderChecked',
                bmBirthday: '#isMemberBirthChecked',
                IDCard: '$isMemberCredentialsChecked,memberCredentialsItems',
                high: '#isMemberHeightChecked',
                weight: '#isMemberWeightChecked',
                jerseysSize: '#isMemberSuitSizeChecked',
                shoesSize: '#isMemberShoeSizeChecked',
                guardianName: '#isMemberParentNameChecked',
                guardianMobile: '#isMemberParentContactPhoneChecked',
                school: '#isMemberSchoolChecked',
                insureFile: '#isMemberInsuranceChecked',
                position: '#isMemberPositionChecked',
                qualificationFile: '#isMemberQualificationChecked',
                jerseyName: '#isMemberSuitNameChecked',
                title: '#isMemberDutyChecked',
                domicileAreaId: '#isMemberCityChecked',
                ethnicity: '#isMemberNationChecked',
                nationality: '#isMemberCountryChecked',
                enterprise: '#isMemberWorkUnitChecked',
                post: '#isMemberProfessionChecked',
                joinTeam: '#isMemberTeamChecked',
                serialNumber: '#isMemberRegistrationCodeChecked',
                isProfessionalPlayer: '#isMemberProfessionalPlayerChecked',
                emergencyContactName: '#isMemberEmergencyContactChecked',
                remark: '#isMemberRemarkChecked',
                certTypeFields: '$memberCredentialsItems',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderId: function(id, options) {
        return options.parameters.matchId
    },
    formatIDCard: function(isMemberCredentialsChecked, memberCredentialsItems) {
        if (isMemberCredentialsChecked && ObjectFunc.convertSelectedItemArray2String(memberCredentialsItems, 'value', '|').length > 0) {
            return 1
        }
        return 0
    },
    formatCertTypeFields: function(memberCredentialsItems) {
        return ObjectFunc.convertSelectedItemArray2String(memberCredentialsItems, 'value', '|')
    },
    renderMemberCredentialsItems: function(certTypeFields) {
        const mappingCode = [0, 1, 3, 2, 11, 5, 4]
        certTypeFields = certTypeFields || ''
        const itemArr = certTypeFields.split('|')
        const items = []
        for (let i = 1; i < 7; i++) {
            let code = mappingCode[i].toString()
            let label = matchSignupPayment.localeProp('signup-member-config-type-6-' + code)
            items.push({
                label: label,
                selected: itemArr.indexOf(code) > -1,
                value: code
            })
        }
        console.log('@renderMemberCredentialsItems', certTypeFields, items)
        return items
    },
    renderIsMemberGenderReadonly: function(genderLimit) {
        return (genderLimit != 3)
    },
    getDefaultMemberCredentialsItems() {
        const mappingCode = [0, 1, 3, 2, 11, 5, 4]
        const items = []
        for (let i = 1; i < 7; i++) {
            let code = mappingCode[i].toString()
            let label = matchSignupPayment.localeProp('signup-member-config-type-6-' + code)
            items.push({
                label: label,
                selected: i == 1 || i == 2,
                value: code
            })
        }
        return items
    },
}

module.exports = tbs_model_vo_MatchSignupMemberConfig